import React from 'react'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import DashboardStatCard from './DashboardStatCard'
import { useDashboardStatsCard } from '../../store/dashboardStats'
import type { DashboardStatCardStationProps } from './types'

const NewMessagesLast24HoursCard: React.FC<DashboardStatCardStationProps> = ({ stationId }) => {
  const { value, loading, error } = useDashboardStatsCard(
    stationId,
    'messagesToday',
  )

  return (
    <DashboardStatCard
      title="Messages Today"
      titleTooltip="Messages received today"
      value={value}
      loading={loading}
      error={error}
      icon={ForumOutlinedIcon}
    />
  )
}

export default NewMessagesLast24HoursCard
